import React, { useState } from 'react'
import emailjs from 'emailjs-com';
import './ServicesAll.scss'
import { Helmet } from "react-helmet";
import NavigatorPath from "../../Tools/NavigatorPath/NavigatorPath"
import { useNavigate } from 'react-router-dom';
import Chimney3 from '../../Images/Chimney3.jpeg'
import bgnobgs from '../../Images/bgnobgs.png'
import AreaData from '../ServicesPage/AreaData'

export default function ServicesAll() {
    const navigate = useNavigate()


    return (
        <div className="ServicesAll">
            <Helmet>
                <title>Chimney Services | Smith and Sons Chimney - Cleaning, Inspection & Repair</title>
                <meta name="title" property="title" content="Chimney Services | Smith and Sons Chimney" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="Chimney Services | Smith and Sons Chimney" data-react-helmet="true" />
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="https://www.smithandsonschimney.com/og.jpg" data-react-helmet="true" />
                <meta name="og:url" property="og:url" content="https://www.smithandsonschimney.com/services" data-react-helmet="true" />
                <link rel="canonical" href="https://www.smithandsonschimney.com/services" />
                <meta name="description" content="Explore the full range of professional chimney services from Smith and Sons Chimney. Sweep, cleaning, inspection, repair, maintenance, liner installation, and more. Call 866-907-7220." data-react-helmet="true" />
                <meta name="og:description" property="og:description" content="Full chimney services from Smith and Sons Chimney." data-react-helmet="true" />
                <meta name="og:site_name" property="og:site_name" content="Smith and Sons Chimney" data-react-helmet="true" />
                <meta name="keywords" content="chimney sweep, chimney cleaning, chimney inspection, chimney repair, chimney maintenance, chimney liner installation, chimney cap, chimney crown repair, creosote removal, smoke chamber repair, masonry repair, chimney waterproofing, Smith and Sons Chimney" data-react-helmet="true" />
                <meta name="robots" content="index, follow, max-image-preview:large" />
                <script type="application/ld+json">{JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "ItemList",
                    "name": "Smith and Sons Chimney — Services",
                    "url": "https://www.smithandsonschimney.com/services",
                    "itemListElement": AreaData.map((A, i) => ({
                        "@type": "ListItem",
                        "position": i + 1,
                        "name": A.Title,
                        "url": `https://www.smithandsonschimney.com${A.Path}`
                    }))
                })}</script>
            </Helmet>
            <div className="ServicesAllTitle">
                <h1>Comprehensive Chimney Services</h1>
                <h2>At Smith and Sons Chimney, we offer a full range of professional chimney services to keep your home safe, warm, and efficient. Whether you need a thorough chimney cleaning, a detailed inspection, or expert repairs, our skilled technicians are here to provide top-quality service. From routine maintenance to addressing complex issues, we ensure your chimney is in optimal condition. Explore our services to find the right solution for your home, and trust Smith and Sons Chimney to deliver the excellence and reliability you deserve.</h2>
            </div>
            <div className="ServicesAllLsit">
                {AreaData.map((A, index) =>
                    <a href={A.Path} className="Header1BoxMenuBox">
                        
                        <div className="ServicesAllBox">
                            <h2>{A.Title}</h2>
                            <h6>{A.TitleShortVery}</h6>
                            <h4>{A.Full}</h4>
                            <h5>EXPLORE THIS SERVICE</h5>
                        </div>
                    </a>
                )}
            </div>

            <NavigatorPath />

        </div>
    )
}

